// @flow

import * as React from "react";

import styles from "./FlashMessages.scss";

import FlashMessageContext from "./FlashMessageContext";
import FlashMessage from "./FlashMessage";

type Message = { id: number, message: React.Node };

type FlashMessageContainerProps = {
  children: React.Node,
  visibilityTimeout: number // in ms
};

type FlashMessageContainerState = {
  counter: number,
  messages: Message[]
};

class FlashMessageContainer extends React.Component<
  FlashMessageContainerProps,
  FlashMessageContainerState
> {
  state = {
    counter: 0,
    messages: []
  };

  addMessage = (message: React.Node, type: "success" | "failure") => {
    const { visibilityTimeout } = this.props;
    this.setState(prevState => ({
      counter: prevState.counter + 1,
      messages: [
        {
          id: prevState.counter,
          message: (
            <FlashMessage
              key={prevState.counter}
              onExited={() => this.removeMessage(prevState.counter)}
              timeouts={{
                enter: 300,
                exit: 500,
                visibility: visibilityTimeout
              }}
              type={type}
            >
              {message}
            </FlashMessage>
          )
        },
        ...prevState.messages
      ]
    }));
  };

  removeMessage = (id: number) =>
    this.setState(prevState => ({
      messages: prevState.messages.filter(m => m.id !== id)
    }));

  render() {
    const { children } = this.props;
    const { messages } = this.state;

    return (
      <FlashMessageContext.Provider value={{ addMessage: this.addMessage }}>
        {children}
        <div className={styles.container}>{messages.map(m => m.message)}</div>
      </FlashMessageContext.Provider>
    );
  }
}

export default FlashMessageContainer;
